import React from 'react';
import * as S from '../Srpcard/Srpcard.styles';
import { Button } from '../../../../components/Button/Button';
import getQueryString from '../../../../utils/QueryValue'

const Srpcard = props => {
  if (props && props.operator) {
    let rtcOfferClick = getQueryString('rtcOfferClick','')
    const { operator } = props;
    const { msg = {} } = operator;
    return (
      <>
        <S.SrpcardLayoutDiv>
          <S.cardInnerConetentlayoutDiv>
            <S.RtcBusWrapDiv>
              <S.BusImageWrapperDiv>
                <img src={operator.image_url} alt="" style={{ height: '100%', width: '100%' }}></img>
              </S.BusImageWrapperDiv>
              <S.BustxtDiv>
                <S.BusBoldtxtPara>{operator.name}</S.BusBoldtxtPara>
                <S.BusNormaltxtPara>{operator.fullName}</S.BusNormaltxtPara>
                {
                  msg?.title &&
                  <S.DiscountTag>
                    <span className="bold" dangerouslySetInnerHTML={{ __html: msg?.title }} />
                  </S.DiscountTag>
                }
              </S.BustxtDiv>
            </S.RtcBusWrapDiv>
          </S.cardInnerConetentlayoutDiv>

          <S.cardInnerConetentSecondlayoutDiv>
            <S.BusTimingWrapDiv>
              <S.BusBoldtxtPara>Starts at {operator.startTime}</S.BusBoldtxtPara>
              <S.BusNormaltxtPara>
                Duration: {operator.minDuration} - {operator.maxDuration}
              </S.BusNormaltxtPara>
            </S.BusTimingWrapDiv>
          </S.cardInnerConetentSecondlayoutDiv>

          <S.cardInnerConetentThirdlayoutDiv>
            <S.BusPriceDetailsDiv>
              <S.BusPriceDiv>
                <S.PriceSeparationDiv>
                  <S.RupeeSpan>&#8377;</S.RupeeSpan>
                  <S.RupeetxtSpan>{operator.startPrice}</S.RupeetxtSpan>
                </S.PriceSeparationDiv>
                <S.BusNormaltxtPara>Starts from</S.BusNormaltxtPara>
              </S.BusPriceDiv>
              <S.BusDetailsDiv>
                <S.BusTimingWrapNewDiv>
                  <S.BusBoldtxtPara>{`${operator.availableBusCount} Bus${operator.availableBusCount > 1 ? 'es' : ''}`}</S.BusBoldtxtPara>
                  <S.BusNormaltxtPara>{`${operator.seatsAvailable} seat${operator.seatsAvailable > 1 ? 's' : ''} left`}</S.BusNormaltxtPara>
                  <S.BusBtnDiv>
                    <Button
                      onClick={() => {
                        props.onClick(operator.opid);
                      }}>
                      <S.PayBtnWrapDiv>
                        <S.PayTxtSpan>{operator.active ? 'HIDE BUSES' : 'SHOW BUSES'}</S.PayTxtSpan>
                      </S.PayBtnWrapDiv>
                    </Button>
                  </S.BusBtnDiv>
                </S.BusTimingWrapNewDiv>
              </S.BusDetailsDiv>
            </S.BusPriceDetailsDiv>
          </S.cardInnerConetentThirdlayoutDiv>
          {/* <BusDetailedTabs /> */}
        </S.SrpcardLayoutDiv>
        {(rtcOfferClick == "true" && msg && Object.keys(msg).length > 0) &&
          <S.DiscountPersuation>
            <img className="femaleIcon" src={msg?.img_url} />
            <span dangerouslySetInnerHTML={{ __html: msg?.desp }} />
          </S.DiscountPersuation>
        }
      </>
    );
  } else {
    return null;
  }
};

export default Srpcard;
